import { useParams } from 'react-router-dom';
import { useProject } from '@/services/project.service';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
    ServerIcon,
    SettingsIcon,
    DownloadIcon,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import FieldView from '../Field/FieldView';
import ProjectSettings from './ProjectSettings';
import ExportTab from '../Export/ExportTab';
import PageHeader from '../../components/PageHeader';
import DeletedBadge from '../../components/DeletedBadge';

export default function ProjectDetails() {
    const { projectId } = useParams();
    const { data: project } = useProject(projectId);
    const { t } = useTranslation();

    if (!project)
        return (
            <div className="max-w-6xl mx-auto px-8 py-10 text-[#7a8077]">
                {t('No project found')}
            </div>
        );

    return (
        <div className="max-w-6xl mx-auto px-8 py-10">
            {project.softDelete && (
                <div className="mb-6 flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-4 py-2.5 text-sm text-red-700">
                    <DeletedBadge />
                    {t(
                        'Hidden from its members; only super admins see it. It can be restored from Settings.',
                    )}
                </div>
            )}
            {/* Samples and scanners are added from the backoffice. */}
            <PageHeader title={project.name} subtitle={project.description} />

            <Tabs defaultValue="devices" className="w-full">
                <TabsList className="bg-transparent border-b border-[#dadbd5] rounded-none p-0 w-full justify-start h-auto">
                    <TabsTrigger
                        value="devices"
                        className="-mb-px rounded-none border-b-2 border-transparent text-[#7a8077] hover:text-[#1c2620] data-[state=active]:border-[#2d6a4f] data-[state=active]:bg-transparent data-[state=active]:text-[#1c2620] data-[state=active]:shadow-none px-4 py-2.5 text-sm font-medium transition-colors"
                    >
                        <ServerIcon className="h-4 w-4 mr-2" />
                        {t('Scanners')}
                    </TabsTrigger>
                    <TabsTrigger
                        value="export"
                        className="-mb-px rounded-none border-b-2 border-transparent text-[#7a8077] hover:text-[#1c2620] data-[state=active]:border-[#2d6a4f] data-[state=active]:bg-transparent data-[state=active]:text-[#1c2620] data-[state=active]:shadow-none px-4 py-2.5 text-sm font-medium transition-colors"
                    >
                        <DownloadIcon className="h-4 w-4 mr-2" />
                        {t('Export')}
                    </TabsTrigger>
                    <TabsTrigger
                        value="settings"
                        className="-mb-px rounded-none border-b-2 border-transparent text-[#7a8077] hover:text-[#1c2620] data-[state=active]:border-[#2d6a4f] data-[state=active]:bg-transparent data-[state=active]:text-[#1c2620] data-[state=active]:shadow-none px-4 py-2.5 text-sm font-medium transition-colors"
                    >
                        <SettingsIcon className="h-4 w-4 mr-2" />
                        {t('Settings')}
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="devices" className="mt-6">
                    <FieldView />
                </TabsContent>
                <TabsContent value="export" className="mt-6">
                    <ExportTab />
                </TabsContent>
                <TabsContent value="settings" className="mt-6">
                    <ProjectSettings />
                </TabsContent>
            </Tabs>
        </div>
    );
}
